// extracted by mini-css-extract-plugin
export default {"titleMobile":"_3Qi3m","dateLocationMobile":"_1cg9T"};